<div class="tab-container" *ngIf="model.otmModules?.length > 0">
  <div
    *ngFor="let module of model.otmModules; let i = index"
    class="sensor-container"
  >
    <span class="input-group-title">Außentemperaturmodul</span>

    <div class="otm-module-button-container">
      <button
        class="secondary otm-load-btn"
        type="button"
        [disabled]="otmVerificationLoading[module.modulId]"
        (click)="loadVerification(module)"
      >
        <span
          *ngIf="otmVerificationLoading[module.modulId]"
          class="otm-spinner"
        ></span>
        <span>Verifikation laden</span>
      </button>
    </div>

    <div *ngIf="otmVerificationError[module.modulId]" class="otm-api-error">
      Verifikation konnte nicht geladen werden:
      {{ otmVerificationError[module.modulId] }}
    </div>

    <div
      *ngIf="
        !otmVerificationLoading[module.modulId] &&
        !module.otmVerification &&
        !otmVerificationError[module.modulId]
      "
      class="otm-empty-state"
    >
      Noch keine Verifikationsdaten geladen.
    </div>

    <ng-container *ngIf="module.otmVerification as v">
      <span
        class="otm-badge"
        [ngClass]="
          v.successfullyValidated ? 'otm-badge--ok' : 'otm-badge--fail'
        "
      >
        {{
          v.successfullyValidated
            ? '✓ Erfolgreich validiert'
            : '✗ Validierung fehlgeschlagen'
        }}
      </span>

      <div class="otm-info-list">
        <div class="otm-info-row">
          <span class="otm-info-label">Datum der Verifikation:</span>
          <span class="otm-info-value">{{
            formatTimestampDE(v.timestamp)
          }}</span>
        </div>
        <div class="otm-info-row">
          <span class="otm-info-label">Sensorname:</span>
          <span class="otm-info-value">{{ v.sensorName || '–' }}</span>
        </div>
        <div class="otm-info-row">
          <span class="otm-info-label">Monteur:</span>
          <span class="otm-info-value">{{ v.monteur || '–' }}</span>
        </div>
        <div class="otm-info-row">
          <span class="otm-info-label">Mittlerer Fehler:</span>
          <span class="otm-info-value">{{
            formatNumberDE(v.meanError, 4)
          }}</span>
        </div>
        <div class="otm-info-row">
          <span class="otm-info-label">Max. Fehler:</span>
          <span class="otm-info-value">{{
            formatNumberDE(v.maxError, 5)
          }}</span>
        </div>
        <div class="otm-info-row">
          <span class="otm-info-label">Kommentar:</span>
          <span class="otm-info-value">{{ v.kommentar || '–' }}</span>
        </div>
      </div>

      <h2 class="otm-section-title">Messungen:</h2>
      <table class="otm-table">
        <thead>
          <tr>
            <th>T (°C)</th>
            <th>R (Ω)</th>
            <th>Abweichung (°C)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rowIdx of getMeasurementRowIndices(v)">
            <td>{{ formatNumberDE(v.measurements?.[rowIdx]?.[0], 1) }}</td>
            <td>{{ formatNumberDE(v.measurements?.[rowIdx]?.[1], 0) }}</td>
            <td class="otm-deviation">
              {{
                v.errors?.[rowIdx] !== undefined
                  ? formatNumberDE(v.errors[rowIdx], 5)
                  : '–'
              }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="otm-bool-section">
        <div class="otm-bool-row">
          <span>Heizung hat Temperaturanzeige:</span>
          <span
            class="otm-bool-value"
            [ngClass]="getBoolClass(v.heatingHasTemperatureDisplay)"
          >
            {{ formatBoolDE(v.heatingHasTemperatureDisplay) }}
          </span>
        </div>
        <div class="otm-bool-row">
          <span>Negative-Temperatur-Test durchgeführt:</span>
          <span
            class="otm-bool-value"
            [ngClass]="
              getBoolClass(v.heatingTurnsOnForNegativeSimulatedTemperature)
            "
          >
            {{ formatBoolDE(v.heatingTurnsOnForNegativeSimulatedTemperature) }}
          </span>
        </div>
      </div>
      <div *ngIf="getOtmWarning(module) as warning" class="weiter-warning">
        <span class="weiter-warning__icon">⚠</span>
        <span>{{ warning }}</span>
      </div>
    </ng-container>
  </div>
</div>

<div class="tab-container" *ngIf="model.otmModules?.length <= 0">
  <div class="input-group-title">Steuerung</div>
  <div class="input-group">
    <label>Soll für diese Heizung eine Steuerung hinzugefügt werden?*</label>
    <div class="radio-wrapper">
      <div class="radio-line">
        <input
          type="radio"
          [value]="true"
          id="shutdownPossibleTrue"
          name="heatingShutdownPossible"
          required
          [(ngModel)]="model.directControl.enabled"
        />
        <label class="radio-label" for="shutdownPossibleTrue">Ja</label>
      </div>
      <div class="radio-line">
        <input
          type="radio"
          [value]="false"
          id="shutdownPossibleFalse"
          name="heatingShutdownPossible"
          required
          [(ngModel)]="model.directControl.enabled"
        />
        <label class="radio-label" for="shutdownPossibleFalse">Nein</label>
      </div>
    </div>
  </div>
  <div class="input-group" *ngIf="model.directControl.enabled">
    <label for="type">Typ</label>
    <input
      type="text"
      name="type"
      id="type"
      [(ngModel)]="model.directControl.type"
    />
  </div>
</div>

<div class="field">Pflichtfelder*</div>
<app-navigation-footer
  [isBackLinkDisabled]="false"
  [backLink]="'/gateway/sensors/counter'"
  [isNextLinkDisabled]="
    !validationService.isSensorsControlValid(model) || !isOtmVerificationValid()
  "
  [nextLink]="'/gateway/sensors/other'"
  [isLast]="false"
></app-navigation-footer>
